import dividerControlHandler from './handlers/divider';
import type { TextEditorControlHandlerMap, TextEditorControlMatrix, TextEditorIconMap } from './TextEditor.vue';

export const TEXT_EDITOR_ALLOWED_CONTROLS = ['bold', 'italic', 'underline', 'link', 'divider', 'list'] as const;

export const TEXT_EDITOR_DEFAULT_TOOLBAR_CONTROLS: TextEditorControlMatrix = [
  ['bold', 'italic', 'underline'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link', 'divider'],
];

export const TEXT_EDITOR_DEFAULT_CONTROL_HANDLERS: TextEditorControlHandlerMap = {
  divider: dividerControlHandler,
};

export const TEXT_EDITOR_ICON_MAP: TextEditorIconMap = {
  bold: 'font-bold',
  italic: 'font-italic',
  underline: 'font-underline',
  list: {
    bullet: 'list-bulleted',
    ordered: 'list-numbered',
  },
  link: 'link',
  divider: 'minus',
};
